module.exports = __webpack_public_path__ + "static/media/minimalUrbanBikeActive.49d28deb.png";